export const date2String = (date: Date | null) => {
    if (!date) {
      return '';
    } else {
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    }
};

export const dateTime2String = (dateTime: Date | null) => {
    if (!dateTime) {
      return '';
    } else {
        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
        const day = dateTime.getDate().toString().padStart(2, '0');
        const year = dateTime.getFullYear();
        const hours = dateTime.getHours().toString().padStart(2, '0');
        const minutes = dateTime.getMinutes().toString().padStart(2, '0');
        return `${month}-${day}-${year} ${hours}:${minutes}`;
    }
};

export const handleSelectedDate = (date: string) => {
    if (date === '') {
        return new Date();
    } else {
        return new Date(date);
    }
};